<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Editar Cliente" @close="$refs.dialog.$dismiss()" />
      <v-card-text class="pa-0 dialog-maxh-calc-buttons overflow-auto">
        <div class="d-flex flex-column pa-3 children-pa-3">
          <OTextField v-model="row.label" label="Nome" />

          <div>
            <OCombobox
              label="Segmento"
              v-model="row.marketSegment"
              :items="allMarketSegments"
              hide-details
            />
          </div>

          <div>
            <OCombobox
              label="Classificação"
              v-model="row.classification"
              :items="allClassifications"
              hide-details
            />
          </div>

          <OTextarea v-model="row.comments" label="Observações" />

          <OTextarea v-model="row.productsDesc" label="Produtos contratados" />
        </div>

        <v-divider/>

        <div class="pa-3 children-pa-3 lighten-3">
          <h3>Documentos</h3>
          <div v-if="row.links.length == 0">(nenhum)</div>
          <div
            class="d-flex items-end justify-stretch"
            v-for="(link, idx) in row.links"
            :key="idx"
          >
            <OTextField v-model="link.text" label="Nome" class="pr-2" />
            <OTextField v-model="link.url" label="URL" class="grow-1" />
            <v-btn icon small @click="removeLink(idx)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
          <div class="text-right">
            <v-btn small @click="addLink">
              Adicionar 1 linha
            </v-btn>
          </div>
        </div>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @cancel="$refs.dialog.$dismiss()"
        @apply="$refs.dialog.$apply(row)"
        txtApply="Salvar"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Customer } from '@/models'
import OCombobox from 'oderon-vue/cpts/OCombobox'

export default {
  components: { OCombobox },
  data() {
    return {
      row: null,
      allMarketSegments: [],
      allClassifications: []
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    addLink() {
      this.row.links.push({ text: '', url: '' })
    },
    removeLink(idx) {
      this.row.links.splice(idx, 1)
    },
    async fetchData() {
      this.allMarketSegments = await Customer.findMarketSegments()
      this.allClassifications = await Customer.findClassifications()
      let row = await Customer.findById(this.id)
      if (row.links == null) row.links = []

      this.row = row
    }
  }
}
</script>

<style></style>
